import React from "react";
import Modal from "../Modal";
import { AdminTenant, CreateUserPayload } from "../../services/api";
import "./UserManagementModals.css";

interface CreateUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  formData: CreateUserPayload;
  setFormData: React.Dispatch<React.SetStateAction<CreateUserPayload>>;
  tenants: AdminTenant[];
  isSuperadmin: boolean;
  currentUserTenantId?: string;
  currentTenantName?: string;
  formError: string;
  isSubmitting: boolean;
}

const CreateUserModal: React.FC<CreateUserModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  formData,
  setFormData,
  tenants,
  isSuperadmin,
  currentUserTenantId,
  currentTenantName,
  formError,
  isSubmitting,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Create New User" maxWidth="500px">
      <div className="user-modal-content">
        {formError && (
          <div className="user-modal-error">
            {formError}
            {(
              formError.toLowerCase().includes("plan limit") 
              || formError.toLowerCase().includes("limit reached")
            ) && (
              <> 
                {' '}
                <a href="/admin?tab=billing" className="upgrade-plan-link">Upgrade your plan to add more users→</a>
              </>
            )}
          </div>
        )}
        <form onSubmit={onSubmit}>
          <div className="user-form-group">
            <label>Email</label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              placeholder="user@example.com"
              required
            />
          </div>
          <p className="user-modal-hint">
            An invite email will be sent so the user can set their own password.
          </p>
          <div className="user-form-group">
            <label>Tenant</label>
            {isSuperadmin ? (
              <select
                value={formData.tenant_id}
                onChange={(e) =>
                  setFormData({ ...formData, tenant_id: e.target.value })
                }
                required
              >
                <option value="">Select a tenant...</option>
                {tenants.map((tenant) => (
                  <option key={tenant.id} value={tenant.id}>
                    {tenant.name}
                  </option>
                ))}
              </select>
            ) : (
              <input
                type="text"
                value={currentTenantName || currentUserTenantId || ""}
                disabled
              />
            )}
          </div>
          <div className="user-form-group">
            <label>Role</label>
            <select
              value={formData.role}
              onChange={(e) =>
                setFormData({ ...formData, role: e.target.value })
              }
            >
              <option value="user">User</option>
              <option value="admin">Admin</option>
            </select>
          </div>
          {isSuperadmin && (
            <div className="user-form-group user-form-checkbox">
              <label htmlFor="is_superadmin">
                <input
                  type="checkbox"
                  id="is_superadmin"
                  checked={formData.is_superadmin}
                  onChange={(e) =>
                    setFormData({ ...formData, is_superadmin: e.target.checked })
                  }
                />
                <span className="user-checkbox-custom"></span>
                <span className="user-checkbox-label">Superadmin privileges</span>
              </label>
            </div>
          )}
          <div className="user-modal-actions">
            <button
              type="button"
              className="user-modal-btn secondary"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="user-modal-btn primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending..." : isSuperadmin ? "Create User" : "Send Invite"}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default CreateUserModal;
